/**
 * Sanitise a form payload before sending it to the API.
 *
 * - Numeric fields: "" → null, string digits → Number
 * - Date fields:    "" → null  (non-empty values passed through as-is)
 * - All other keys: untouched
 */
export function cleanFormPayload<T extends Record<string, any>>(
  payload: T,
  opts: {
    numericFields?: string[];
    dateFields?: string[];
  } = {},
): T {
  const { numericFields = [], dateFields = [] } = opts;
  const numSet = new Set(numericFields);
  const dateSet = new Set(dateFields);

  const out: Record<string, any> = {};
  for (const [key, value] of Object.entries(payload)) {
    if (numSet.has(key)) {
      if (value === '' || value === undefined) {
        out[key] = null;
      } else {
        out[key] = Number(value);
      }
    } else if (dateSet.has(key)) {
      out[key] = value === '' ? null : value;
    } else {
      out[key] = value;
    }
  }
  return out as T;
}
